<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.domain_tool_settings.form.url')"
            :is-required="true"
            :error="errors.url"
            :hint="__('settings.domain_tool_settings.form.url_hint')"
        >
            <DInput
                id="url"
                v-model="form.url"
                :placeholder="__('settings.domain_tool_settings.form.url')"
                :is-valid="isFormFieldValid('url')"
                type="text"
            />
        </DFormRow>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'DomainToolSettingsForm',
    props: {
        domainToolSettings: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                url: this.domainToolSettings?.url ?? ''
            })
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        }
    }
}
</script>
